export default angular.module('gazelle.bundles.users', [
  // gzUserPanel,
]).name;
